var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42492 17.2248C7.26659 17.2248 7.10825 17.1664 6.98325 17.0414C6.74159 16.7998 6.74159 16.3998 6.98325 16.1581L12.4166 10.7248C12.8166 10.3248 12.8166 9.67477 12.4166 9.27477L6.98325 3.84144C6.74159 3.59977 6.74159 3.19977 6.98325 2.95811C7.22492 2.71644 7.62492 2.71644 7.86658 2.95811L13.2999 8.39144C13.7249 8.81644 13.9666 9.39144 13.9666 9.99977C13.9666 10.6081 13.7333 11.1831 13.2999 11.6081L7.86658 17.0414C7.74158 17.1581 7.58325 17.2248 7.42492 17.2248Z",
    fill: "#288564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.fda92ece4c16bfc86972fd2863d03c7c.svg";
export { ForwardRef as ReactComponent };